export const sitesDropdown = [
	{ site: "Royal Free", hospital: true },
	{ site: "Barnet", hospital: true },
	{ site: "Chase Farm", hospital: true },
	{ site: "Chalk Mill", hospital: false },
	{ site: "Hadley Wood", hospital: false },
	{ site: "Tottenham Hale", hospital: false },
	{ site: "Graseby House", hospital: false },
	{ site: "PEARS Building", hospital: false },
	{ site: "Queen Mary's House", hospital: false },
	{ site: "North Middlesex Hospital", hospital: false },
	{ site: "Whittington Hospital", hospital: false },
	{ site: "WHT - Bounds Green Health Centre", hospital: false },
	{ site: "WHT - Crouch End Health Centre", hospital: false },
	{ site: "WHT - Stuart Crescent Health Centre", hospital: false },
	{ site: "WHT - Tynemouth Road Health Centre", hospital: false },
	{ site: "WHT - Goodinge Health Centre", hospital: false },
	{ site: "WHT - Highbury Grange Health Centre", hospital: false },
	{ site: "WHT - Hornsey Rise Health Centre", hospital: false },
	{ site: "WHT - Northern Health Centre", hospital: false },
	{ site: "WHT - River Place Health Centre", hospital: false },
	{ site: "WHT - Wood Green Diagnostic Centre", hospital: false },
];
